import { JSX, useEffect, useRef, useState } from 'react'

import { IPosition } from '../PinOutPortal'

import { PinOutContext } from './context/PinOutContext'

interface IProps {
  setInitialPos?: (pos: IPosition) => void
  setWidth?: (w: string) => void
  setHeight?: (h: string) => void
  height?: string
  width?: string
  children?: JSX.Element | Array<JSX.Element>
  hidePinOut?: boolean
}
let savedWidth: any = 0
let savedHeight: any = 0
export const WidgetPlaceholder = ({
  height,
  setInitialPos,
  setWidth,
  setHeight,
  children,
  hidePinOut,
  width,
}: IProps) => {
  const [mutable] = useState({ height: 0, width: 0, top: 0, left: 0 })
  const [unpinnedWidth, setUnpinnedWidth] = useState('')
  const [unpinnedHeight, setUnpinnedHeight] = useState('')
  const ref = useRef(null)

  useEffect(() => {
    if (!children && !unpinnedWidth) {
      setUnpinnedWidth(savedWidth)
      setUnpinnedHeight(savedHeight)
      setWidth && setWidth(`${savedWidth}`)
    } else if (children && !unpinnedWidth && width) {
      setUnpinnedWidth(savedWidth)
      setUnpinnedHeight(savedHeight)
    }
  }, [children])

  useEffect(() => {
    return () => {
      if (ref.current) {
        // @ts-ignore
        savedWidth = ref.current['scrollWidth']
        // @ts-ignore
        savedHeight = ref.current['scrollHeight']
      }
    }
  }, [])

  useEffect(() => {
    let currRef: HTMLDivElement | null = ref.current
    if (currRef !== null) {
      currRef = currRef as HTMLDivElement
      if (setHeight && mutable.height !== ref.current!['scrollHeight']) {
        setHeight(`${currRef['scrollHeight']}`)
        mutable.height = currRef!['scrollHeight']
      }
      if (setWidth && mutable.width !== currRef['scrollWidth']) {
        mutable.width = currRef['scrollWidth']
      }
      const pos = currRef.getBoundingClientRect()
      if (mutable.top !== pos.top || mutable.left !== pos.left) {
        setInitialPos && setInitialPos({ top: `${pos.top}`, left: `${pos.left}` })
        mutable.top = pos.top
        mutable.left = pos.left
      }
    }
  }, [children])

  if (hidePinOut) {
    return null
  }

  return (
    <PinOutContext.Consumer>
      {(pinout) => {
        return (
          <div
            ref={ref}
            style={{
              backgroundColor: 'gray',
              height: unpinnedHeight ? unpinnedHeight : 'auto',
              width: unpinnedWidth,
            }}
          >
            {children ? (
              children
            ) : (
              <>
                <span>Pinned out widget</span>
                <button onClick={() => pinout.onRmvPlaceHolder(true)}>Remove</button>
              </>
            )}
          </div>
        )
      }}
    </PinOutContext.Consumer>
  )
}
